<template>
  <card>
    <h4 slot="header" class="card-title">Yeni Kumbara</h4>
    <a-form-model
      ref="ruleForm"
      :model="form"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
      labelAlign="left"
      >
      <a-form-model-item ref="code" label="Kumbara Kodu" prop="code">
        <a-input
          placeholder="Kumbara Kodu"
          v-model="form.code"
          @blur="
            () => {
              $refs.name.onFieldBlur();
            }
          "
        />
      </a-form-model-item>
      <a-form-model-item ref="name" label="Kumbara Adı" prop="name">
        <a-input
          placeholder="Kumbara Adı"
          v-model="form.name"
          @blur="
            () => {
              $refs.name.onFieldBlur();
            }
          "
        />
      </a-form-model-item>
      <a-form-model-item ref="address" label="Açık Adres" prop="address">
        <a-textarea
          placeholder="Açık Adres"
          v-model="form.address"
          @blur="
            () => {
              $refs.address.onFieldBlur();
            }
          "
        />
      </a-form-model-item>
      <a-form-model-item ref="description" label="Detay" prop="description">
        <a-textarea
          v-model="form.description"
          placeholder="Detay"
        />
      </a-form-model-item>
      <a-form-model-item
        help="Kaç günde bir boşaltma işlemi yapılması gerektiği bilgisini ifade eder." 
        ref="unload_interval" 
        label="Boşaltma Periyodu" 
        prop="unload_interval">
        <a-input-number
          placeholder="Periyot"
          v-model="form.unload_interval"
          :min="1" 
          :max="100" />
      </a-form-model-item>
      <a-form-model-item :wrapper-col="{ span: 14, offset: 5 }">
        <a-button :loading="loading" type="primary" @click="onSubmit">
          Oluştur
        </a-button>
        <a-button style="margin-left: 10px;" @click="resetForm">
          Sıfırla
        </a-button>
      </a-form-model-item>
    </a-form-model>
  </card>
</template>
<script>
  import Card from 'src/components/Cards/Card.vue'

  export default {
    components: {
      Card
    },
    watch:{
      "form.code": {
        handler(newV, oldV){
          this.$emit("codeChange", newV)
        }
      }
    },
    data () {
      return {
        loading: false,
        labelCol: { span: 4 },
        wrapperCol: { span: 10 },
        form: {
          code: '',
          name: '',
          address: '',
          description: '',
          unload_interval: 0
        },
        rules: {
          code: [
            { required: true, message: 'Kod alanını boş bırakmayınız', trigger: 'blur' },
            { min: 3, max: 50, message: 'Kod alanı min 3, max 50 karakter uzunluğunda olabilir', trigger: 'blur' },
          ],
          name: [
            { required: true, message: 'Kumbara Adı alanını boş bırakmayınız', trigger: 'blur' },
            { min: 3, max: 50, message: 'Kumbara Adı alanı min 3, max 50 karakter uzunluğunda olabilir', trigger: 'blur' },
          ],
          address: [
            { required: true, message: 'Adres alanını boş bırakmayınız', trigger: 'blur' },
            { min: 3, max: 200, message: 'Adres alanı min 3, max 200 karakter uzunluğunda olabilir', trigger: 'blur' },
          ],
          description: [
            { required: false, message: 'Detay alanını boş bırakmayınız', trigger: 'blur' },
            { min: 3, max: 500, message: 'Detay alanı min 3, max 500 karakter uzunluğunda olabilir', trigger: 'blur' },
          ],
        },
      }
    },
    methods: {
      onSubmit() {
        const self = this
        this.$refs.ruleForm.validate(valid => {
          if (valid) {
            self.loading = true
            const { unload_interval: _, ...data } = self.form;
            self.$store.dispatch("Moneybox/requestMoneyboxCreate", data).then((moneybox)=> {
              self.$notification['success']({
                message: 'Kumbara Ekleme',
                description:
                  'Kumbara başarılı bir şekilde oluşturuldu :)',
              });
              if(self.form.unload_interval > 0){
                self.$store.dispatch("Moneybox/requestMoneyboxUnloadIntervalCreate", {
                  moneybox_id: moneybox.id,
                  interval: self.form.unload_interval
                })
              }
              self.$router.push('/admin/money-boxes/')
            }).catch(()=> {
              self.$notification['error']({
                message: 'Kumbara Ekleme',
                description:
                  'Kumbara eklenirken bir hata oluştu :/',
              });
            }).finally(()=> {
              self.loading = false
            })
            console.log("asdasds")
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      resetForm() {
        this.$refs.ruleForm.resetFields();
      }      
    }
  }

</script>
<style>

</style>
